export function getPhoneDigitsFromPattern(pattern?: string) {
  if (!pattern) {
    return ''
  }

  const quantifiers = pattern.match(/\{\d+(?:,\d+)?\}/g)
  const lastQuantifier = quantifiers?.[quantifiers.length - 1]

  return lastQuantifier?.match(/\d+/)?.[0] ?? ''
}

export function getPhoneExampleFromDigits(phoneDigits: string) {
  const digitsCount = Number(phoneDigits)
  if (!Number.isInteger(digitsCount) || digitsCount <= 0) {
    return ''
  }

  return Array.from({ length: digitsCount }, (_, index) => String(index % 10)).join('')
}
